import type { SaveButtonState } from './types'

export const liveInputActionIcons = {
  COMMENT: 'fa fa-comment',
  UNDO: 'fa fa-undo',
  TRASH: 'fa fa-regular fa-trash-can',
  INSIGHTS: 'icon-insights-from-file-path', // this is just an identifier used throughout the code, the actual icon is provided via a file path for this one
} as const

export type LiveInputActionsIcon =
  typeof liveInputActionIcons[keyof typeof liveInputActionIcons]

export const liveInputActionContainer = 'live-input-action-container'

const liveInputNamespace = 'LIVE_INPUT'

export const liveInputEvents = {
  ACTION_CLICKED: `${liveInputNamespace}:ACTION_CLICKED`,
  INSIGHTS_ACTION_CLICKED: `${liveInputNamespace}:INSIGHTS_ACTION_CLICKED`,
  CLICKED_OUTSIDE_ACTIONS: `${liveInputNamespace}:CLICKED_OUTSIDE_ACTIONS`,
  MOUSE_ENTERED_ACTION: `${liveInputNamespace}:MOUSE_ENTERED_ACTION`,
  MOUSE_LEFT_ACTION: `${liveInputNamespace}:MOUSE_LEFT_ACTION`,
  SHOW_ACTIONS: `${liveInputNamespace}:SHOW_ACTIONS`,
  HIDE_ACTIONS: `${liveInputNamespace}:HIDE_ACTIONS`,
} as const

export const saveButtonFeatures: Record<
  SaveButtonState,
  {
    text: string
    classes: string
    icon?: string | null
    tooltip?: string | null
  }
> = {
  disabled: {
    text: 'js.live_inputs.interact.save',
    classes: 'sf-btn sf-disabled',
  },
  hidden: {
    text: 'js.live_inputs.interact.save',
    classes: 'tw-hidden',
  },
  save: {
    text: 'js.live_inputs.interact.save',
    classes:
      'sf-btn tw-text-sf-success hover:tw-text-sf-success hover:tw-bg-sf-snow hover:tw-border-sf-snow hover:tw-shadow-none',
  },
  saving: {
    text: 'js.live_inputs.interact.saving',
    classes:
      'tw-pointer-events-none tw-text-sf-gray-darker tw-font-medium tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-transparent tw-leading-5',
  },
  saved: {
    text: 'js.live_inputs.interact.saved',
    classes:
      'tw-pointer-events-none tw-text-sf-gray-darker tw-font-medium tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-transparent tw-leading-5',
    icon: 'fa fa-check',
  },
  failed: {
    text: 'js.live_inputs.interact.retry',
    classes: 'sf-btn tw-text-sf-danger',
    icon: 'fa fa-exclamation-circle',
    tooltip: 'js.live_inputs.interact.failed_to_save',
  },
}

export const INPUTS_WITH_PREVIEW_SELECTORS = [
  'StringInput',
  'CurrencyInput',
  'CurrencyDcInput',
  'DateInput',
  'TextInput',
  'PercentageInput',
  'IntegerInput',
  'SelectInput',
]
export const WORKFLOW_PROGRESS_TIMEOUT = 5 * 1000

export const LIVE_INPUT_ASYNC_TEMPLATE_FETCH_TIMEOUT = 55 * 1000
export const TAB = 9
export const ENTER = 13
export const NUMERIC_INPUTS = [
  'integer',
  'currency',
  'currency_dc',
  'n_currency',
  'percentage',
]
export const VALIDATION_DELAY = 500
